var _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 900,
    height: 600,
    viewBox: "-36 -24 72 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-36-24h72v48h-72z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-56.31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M-6-26H6v2H-6zm0 3H6v2H-6zm0 3H6v2H-6z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    y: 44
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M0 17v10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cd2e3a",
    d: "M0-12a12 12 0 0 1 0 24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047a0",
    d: "M0-12a12 12 0 0 0 0 24A6 6 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cy: -6,
    fill: "#cd2e3a",
    r: 6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-123.69)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M0-23.5v3M0 17v3.5m0 3v3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKr);
export default __webpack_public_path__ + "static/media/kr.f208d9d8bd5961c044620c5ce7a12f97.svg";
export { ForwardRef as ReactComponent };